import { createFileRoute } from '@tanstack/react-router'

import { RetryAnalysisScreen } from './-components/retry-analysis-screen.tsx'

export const Route = createFileRoute('/payments/retry-analysis')({
  component: RetryAnalysisScreen
})
